export const suspectedStorageKey = 'suspected_pro_last_close';
export const suspectedOpenedStorageKey = 'suspected_pro_has_been_opened';
